// extracted by mini-css-extract-plugin
export default {"root":"PaymentError_root__V7ZWt","test":"PaymentError_test__0xBlK"};